import { render, staticRenderFns } from "./Daten.vue?vue&type=template&id=6d579291&scoped=true"
import script from "./Daten.vue?vue&type=script&lang=js"
export * from "./Daten.vue?vue&type=script&lang=js"
import style0 from "./Daten.vue?vue&type=style&index=0&id=6d579291&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d579291",
  null
  
)

export default component.exports